/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewEncapsulation,
} from '@angular/core';
import { LegendPosition, PieChartComponent, ScaleType } from '@swimlane/ngx-charts';
import { CustomChartComponent } from './custom-chart.component';
import { CustomPieSeriesComponent } from './custom-pie-series.component';

@Component({
    selector: 'dash-gis-custom-pie-chart',
    templateUrl: './custom-pie-chart.component.html',
    styleUrls: ['./custom-pie-chart.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CustomChartComponent, CustomPieSeriesComponent],
})
export class CustomPieChartComponent extends PieChartComponent implements OnChanges, AfterViewInit, OnDestroy {
    // inputs/outputs from BaseChartComponent
    @Input() scheme: any = 'cool';
    @Input() schemeType = ScaleType.Ordinal;
    @Input() animations = true;

    // inputs/outputs from PieChartComponent
    @Input() labels = false;
    @Input() legend = false;
    @Input() legendTitle = 'Legend';
    @Input() legendPosition = LegendPosition.Right;
    @Input() explodeSlices = false;
    @Input() doughnut = false;
    @Input() arcWidth = 0.25;
    @Input() activeEntries: any[] = [];
    @Input() tooltipDisabled = false;
    @Input() trimLabels = true;
    @Input() maxLabelLength = 10;
    @Output() dblclick = new EventEmitter();
    @Output() select = new EventEmitter();
    @Output() activate: EventEmitter<any> = new EventEmitter();
    @Output() deactivate: EventEmitter<any> = new EventEmitter();

    ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
